var _circle, _path, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSkytechCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Skytech") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#FFFFFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(-16.305 -8.995) scale(0.0568)",
    fill: "#CD5500",
    d: "M403.26 314C370.39 314 353.96 299.21 353.96 269.63C353.96 240.05 370.39 225.26 403.26 225.26H501.86V254.84H408.19C391.75 254.84 383.54 259.77 383.54 269.63C383.54 279.49 391.75 284.42 408.19 284.42H452.56C485.43 284.42 501.86 299.21 501.86 328.79C501.86 358.37 485.43 373.16 452.56 373.16H353.96V343.58H447.63C464.06 343.58 472.28 338.65 472.28 328.79C472.28 318.93 464.07 314 447.63 314H403.26Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.85,
    fill: "none",
    stroke: "#000",
    strokeOpacity: 0.12,
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkytechCircle);
export default __webpack_public_path__ + "static/media/skytech-circle.2536f9cca8d594556e6aa15df8b03dbb.svg";
export { ForwardRef as ReactComponent };